
import Vue from 'vue';

import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';

// @ts-ignore
import lt from 'vue2-datepicker/locale/lt';
// @ts-ignore
import ru from 'vue2-datepicker/locale/ru';
// @ts-ignore
import en from 'vue2-datepicker/locale/en';

// @ts-ignore
import { directive as clickOutside } from 'v-click-outside-x';

import MenuLightbox from '@root/common/components/base/MenuLightbox.vue';
import isMobileView from '@root/common/utils/isMobileView';
import { faArrowRotateLeft } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

interface Props {
  value: string[] | null;
  placeholder: string;
}

interface Data {
  date: string[] | null;
  isMobileView: boolean;
  locale: any;
  showDatePicker: boolean;
}

interface Methods {
  closeDatePicker: () => void;
  disabledDate: (value: Date) => boolean;
  handleInput: (value: Date[]) => void;
  toggleDatePicker: () => void;
}

interface Computed {
  dateString: string | null;
  lang: Record<string, any>;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: {
    clickOutside,
  },
  components: {
    DatePicker,
    MenuLightbox,
  },
  props: {
    value: {
      type: undefined,
      default: null,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      date: null,
      isMobileView: false,
      locale: 'lt',
      showDatePicker: false,
      faArrowRotateLeft,
    };
  },
  computed: {
    dateString() {
      if (this.date?.length) {
        return `${this.$options.filters?.formatDate(this.date[0])} - ${this.$options.filters?.formatDate(this.date[1])}`;
      }

      return null;
    },
    lang() {
      let locale = null;

      if (this.locale === 'lt') {
        locale = lt;
      }

      if (this.locale === 'ru') {
        locale = ru;
      }

      if (this.locale === 'en') {
        locale = en;
      }

      const overrides = {
        monthFormat: 'MMMM',
      };

      locale.formatLocale.monthsShort = locale.formatLocale.months;

      return { ...locale, ...overrides };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.date = this.value;
      },
    },
  },
  mounted() {
    this.isMobileView = isMobileView();

    const { locale } = this.$channelConfig('settings');
    const localeString = locale.split('_')[0];

    switch (localeString) {
      case 'ru':
        this.locale = 'ru';
        break;
      case 'en':
        this.locale = 'en';
        break;
    }
  },
  methods: {
    closeDatePicker() {
      this.showDatePicker = false;
    },
    disabledDate(date) {
      return date > new Date();
    },
    handleInput(value) {
      this.$emit('input', value);
      this.toggleDatePicker();
    },
    toggleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
    },
  },
});
